// 常量定义

// API 基础配置
export const API_CONFIG = {
  BASE_URL: process.env.VUE_APP_API_BASE_URL || 'http://localhost:8080',
  API_KEY: process.env.VUE_APP_API_KEY || ''
}

// 指标类型映射
export const INDICATOR_TYPES = {
  LIVER: 'liver',           // 肝脏
  STOMACH: 'stomach',       // 胃
  KIDNEY: 'kidney',         // 肾脏
  CARDIOVASCULAR: 'cardiovascular', // 心血管
  BREATHING: 'breathing',   // 呼吸
  ENDOCRINE: 'endocrine',   // 内分泌
  EYE: 'eye',               // 眼部
  FEMALE: 'female',         // 女性
  IMMUNE: 'immune',         // 免疫
  SKIN: 'skin',             // 皮肤
  BONES: 'bones',           // 骨骼
  VITAMIN: 'vitamin',       // 维生素
  ANDROLOGY: 'andrology'    // 男科
}

// 指标名称映射
export const INDICATOR_NAMES = {
  [INDICATOR_TYPES.LIVER]: '肝脏功能',
  [INDICATOR_TYPES.STOMACH]: '胃功能',
  [INDICATOR_TYPES.KIDNEY]: '肾脏功能',
  [INDICATOR_TYPES.CARDIOVASCULAR]: '心血管功能',
  [INDICATOR_TYPES.BREATHING]: '呼吸功能',
  [INDICATOR_TYPES.ENDOCRINE]: '内分泌功能',
  [INDICATOR_TYPES.EYE]: '眼部功能',
  [INDICATOR_TYPES.FEMALE]: '女性功能',
  [INDICATOR_TYPES.IMMUNE]: '免疫功能',
  [INDICATOR_TYPES.SKIN]: '皮肤功能',
  [INDICATOR_TYPES.BONES]: '骨骼功能',
  [INDICATOR_TYPES.VITAMIN]: '维生素',
  [INDICATOR_TYPES.ANDROLOGY]: '男科功能'
}

// 风险等级
export const RISK_LEVELS = {
  HIGH: 'high',     // 高风险
  MEDIUM: 'medium', // 中风险
  LOW: 'low'        // 低风险
}

// 风险等级名称
export const RISK_LEVEL_NAMES = {
  [RISK_LEVELS.HIGH]: '高风险',
  [RISK_LEVELS.MEDIUM]: '中风险',
  [RISK_LEVELS.LOW]: '低风险'
}

// 风险等级颜色
export const RISK_LEVEL_COLORS = {
  [RISK_LEVELS.HIGH]: '#FF4D4F',
  [RISK_LEVELS.MEDIUM]: '#FA8C16',
  [RISK_LEVELS.LOW]: '#90BB55'
}

// 路由路径
export const ROUTE_PATHS = {
  HOME: '/',
  HEALTH_ASSESSMENT: '/health-assessment',
  PSYCHOLOGICAL_AGE: '/psychological-age',
  TONGUE_DIAGNOSIS: '/tongue-diagnosis',
  PULSE_DIAGNOSIS: '/pulse-diagnosis',
  HEALTH_SERVICE: '/health-service'
}

// 路由名称
export const ROUTE_NAMES = {
  HOME: 'Home',
  HEALTH_ASSESSMENT: 'HealthAssessment',
  PSYCHOLOGICAL_AGE: 'PsychologicalAge',
  TONGUE_DIAGNOSIS: 'TongueDiagnosis',
  PULSE_DIAGNOSIS: 'PulseDiagnosis',
  HEALTH_SERVICE: 'HealthService'
}

// 页面标题
export const PAGE_TITLES = {
  [ROUTE_NAMES.HOME]: '健康诊断报告',
  [ROUTE_NAMES.HEALTH_ASSESSMENT]: '健康评估',
  [ROUTE_NAMES.PSYCHOLOGICAL_AGE]: '生理年龄',
  [ROUTE_NAMES.TONGUE_DIAGNOSIS]: '舌诊检测',
  [ROUTE_NAMES.PULSE_DIAGNOSIS]: '脉诊检测',
  [ROUTE_NAMES.HEALTH_SERVICE]: '健康服务'
}

